import { Injectable } from '@angular/core';
import * as angular from 'angular';

@Injectable({
    providedIn: 'root'
})
export class ScrollbarService {
    public static $name: string = 'scrollbarService';

    /**
     * Cache the computed scroll bar size, so we don't have to create and destroy divs all day.
     */
    private _scrollbarSize: number;

    public getScrollbarSize(): number {
        return this._scrollbarSize || this.calculateScrollbarSize();
    }

    /**
     * Creates a small overflowed div out of the normal flow of the screen with another div inside,
     * then measures the difference and destroys both.
     * This is a cross-browser way of determining how many px wide/tall the scroll bar is.
     */
    private calculateScrollbarSize() {
        let base = 100;

        let $outer = angular.element('<div>').css({
            height: base,
            overflow: 'scroll',
            position: 'absolute',
            visibility: 'hidden',
            width: base
        });

        $outer.appendTo('body');

        let $inner = angular.element('<div>').css({
            width: '100%'
        });

        $inner.appendTo($outer);

        this._scrollbarSize = base - $inner.outerWidth();

        $outer.remove();

        return this._scrollbarSize;
    }
}
